import { useMemo } from 'react';
import { ViewFormResponseFormFields } from '../model';

// Gates whether form-field comment affordances (context menu item, comment indicator) render
// at all for the currently viewed form. Forms with no overridable fields behave exactly as
// they do without this feature.
export const useFormHasEditableFields = (formFields: ViewFormResponseFormFields | undefined): boolean => {
    return useMemo(() => {
        if (!formFields) {
            return false;
        }

        return Object.values(formFields).some((instances) => instances.some((field) => field.overridable));
    }, [formFields]);
};
